import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwt2zq4an7: FaireProductEntity = {
  token: "p_uwt2zq4an7",
  type: "product",
  name: "Drink Palestina Orange Flavor 12FL OZ (355mL) cans",
  brandToken: "b_p3ed87kb2a",
  brandName: "SaniLLC",
  imageUrl:
    "https://cdn.faire.com/fastly/f267db3e24861c5e0808a9062251d53fff4f7825881f74eecdaae2d670e80e47.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    "Drink Palestina Flavored Drinking Orange | Refreshing, Flavorful and Non Alcoholic Beverages | 12FL OZ (355mL) cans - Orange\n",
  tags: [],
  msrpDollars: 11.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:49.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
